/**
 * @generated SignedSource<<9112afa4faf8d3416fb05e178989df96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReceiverStoresSelectorTeamsIndicator_teams$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
  readonly " $fragmentType": "ReceiverStoresSelectorTeamsIndicator_teams";
}>;
export type ReceiverStoresSelectorTeamsIndicator_teams$key = ReadonlyArray<{
  readonly " $data"?: ReceiverStoresSelectorTeamsIndicator_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorTeamsIndicator_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ReceiverStoresSelectorTeamsIndicator_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIconCircle"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "eb78f8e91569ed1b1360be0d90d1b653";

export default node;
